import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import TextRenderer from '../../../TextRenderer';
import { ShortStatusViewer, LongStatusViewer, } from '../../../DaEditorWrapper/Viewer/Status';
import { getIsShortStatus, getStatusBackgroundProps } from '../../_helpers';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import LoadingIndicator from '../../../LoadingIndicator';
import Background from '../../../Background';
import SubPaywall from '../_partials/SubPaywall';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import s from './Status.scss';
export var StatusFullView = function (_a) {
    var textContent = _a.deviation.textContent, deviation = _a.deviation, width = _a.width;
    var backgroundProps = getStatusBackgroundProps(deviation);
    var _b = useSubscriptionTier(deviation), isSubscribedButBlocked = _b.isSubscribedButBlocked, needsSubscription = _b.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    if (isBlocked) {
        return React.createElement(SubPaywall, { deviation: deviation, isStatusArtStage: true });
    }
    if (!textContent) {
        return null;
    }
    if (!textContent || !(textContent.excerpt || textContent.html.markup)) {
        return null;
    }
    // Display logic
    // Legacy gets its own styles
    // If any media inserted it cant be short
    var isLegacy = textContent.html.type === 'writer';
    var isShortStatus = getIsShortStatus(deviation);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return (React.createElement("div", { className: classnames(s['root'], isLegacy && s['legacy'], isShortStatus && s['short-status']) },
        isExtendedLoaded && (React.createElement(React.Fragment, null,
            backgroundProps && (React.createElement(Background, __assign({ className: s['background-wrapper'], width: width, variant: "status" }, backgroundProps))),
            React.createElement(TextRenderer, { textContent: textContent, className: s['text'], reactViewer: isShortStatus ? ShortStatusViewer : LongStatusViewer, legacyTheme: isShortStatus ? 'short-status' : 'status', viewerKey: deviation.deviationId, width: '100%' }))),
        !isExtendedLoaded && React.createElement(LoadingIndicator, { view: "llama", coverMode: true })));
};
StatusFullView.displayName = 'StatusFullView';
export default StatusFullView;
//# sourceMappingURL=Status.js.map